import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInDown } from 'ng-animate';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiurlsService } from '../../../../services/api-urls/apiurls.service';
import { UtilityService } from '../../../../services/utilities/utilities.services';
import { ApirequestService } from '../../../../services/apirequest/apirequest.service';

@Component({
  selector: 'hybse-admin-add-ibo',
  templateUrl: './add-ibo.component.html',
  styleUrls: ['./add-ibo.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ],
})
export class AddIboComponent implements OnInit {

  constructor(
    private _fb: FormBuilder,
    private _urls: ApiurlsService,
    private _ar: ActivatedRoute,
    private _utils: UtilityService,
    private router: Router,
    private _ac: ActivatedRoute,
    private _api: ApirequestService
  ) { }
  @Input() actionType: string = 'add';
  marketList: any = [];
  fadeInDown: any;
  showLoader: boolean = false;
  createIBOForm: FormGroup;
  startDate = new Date();
  responseMessage: string = '';
  alertStatusMessage: boolean = false;
  iboId: any = '';
  iboData: any = '';
  symbolList: any = [];
  companyList: any = [];
  targetSymbol: any = [];
  ibinCompany: string;
  targetPair:any;
  @Input() isDemo: boolean = false;

  createIBOFormInit() {
    this.createIBOForm = this._fb.group({
      'source_symbol': ['', (this.actionType == 'add') ? [Validators.required, Validators.max(4)] : []],
      'target_symbol': ['', (this.actionType == 'add') ? [Validators.required] : []],
      'companies': ['', (this.actionType == 'add') ? [Validators.required] : []],

      'source_symbol_edit': ['', (this.actionType == 'edit') ? [Validators.required, Validators.max(4)] : []],
      'target_symbol_edit': ['', (this.actionType == 'edit') ? [Validators.required] : []],
      'companies_edit': ['', (this.actionType == 'edit') ? [Validators.required] : []],

      'initial_value': ['', [Validators.required]],
      // 'ask_price': ['', [Validators.required,this.numberValidation]],
      'ask_size': ['', [Validators.required, this.numberValidation]],
      'nemMosaic': ['', Validators.required],
      'nemNamespace': ['', Validators.required],
      'lockupDate': ['', [Validators.required]],
      'userId': [''],
      'ibin': [null],
      'discountList': this._fb.array(this.createDiscountFields())
    });
  }

  get formData() { return <FormArray>this.createIBOForm.get('discountList'); }

  createDiscount(discVal: any = '', expiry: any = '', id: any = ''): FormGroup {
    return this._fb.group({
      'discount': [(discVal != '') ? discVal : '', [Validators.required, Validators.min(0), Validators.max(100), this.numberValidation]],
      'expiry': [(expiry != '') ? expiry : '', [Validators.required]],
      'idLockupStock': [(id != '') ? id : '']
    });
  }

  createDiscountFields() {
    let disArr = [];
    let count = 3;
    if (this.actionType == 'add') {
      for (var i = 1; i <= count; i++) {
        disArr.push(this.createDiscount())
      }

    } else {
      disArr.push(this.createDiscount())
    }
    return disArr;

  }

  getUserId(e) {
    if (this.marketList.length > 0) {
      let userIdObj = this._utils.filteredObj(this.marketList, 'idCompanyStock', e.value);
      this.createIBOForm.get('userId').setValue(userIdObj[0].idUser);
    }
  }


  createUpdateSubmit() {
    if (this.createIBOForm.valid) {
      this.showLoader = true;
      let formVal = this.createIBOForm.value;
      let idCompany = this._utils.filteredObj(this.companyList, 'idCompany', formVal.companies);
      //  console.log(idCompany);
      if (this.actionType == 'add') {
        let data: any = {
          idCompany: formVal.companies,
          pairSource: formVal.source_symbol,
          idPairTarget: formVal.target_symbol,
          pairTarget: this.targetPair,
          companyName: idCompany[0].companyName,
          initialValue: formVal.initial_value,
          lockupDate: formVal.lockupDate,
          nemMosaic: formVal.nemMosaic,
          nemNamespace: formVal.nemNamespace,
          // askPrice: formVal.ask_price,
          askSize: formVal.ask_size,
          lockupStock: formVal.discountList
        }

        this._api.fetchApiData(this._urls.createIBOUrl, data).subscribe(
          (data: any) => {
            let resSucc = data.data;
            let resErr = data.error;
            this._utils.scrollToY(0, 400, 'easeInOutQuint');
            if (resSucc != '') {
              this.alertStatusMessage = true;
              this.responseMessage = resSucc['Success Description'];
              setTimeout(() => {
                this.router.navigate(['ibo/list']);
              }, 2000);
            }
            if (resErr != '') {
              this.alertStatusMessage = false;
              this.responseMessage = resErr['Error Description'];
            }

          },
          error => {

          },
          () => {
            this.showLoader = false;
          }
        )
      }

      if (this.actionType == 'edit') {
        let data: any = {
          idCompanyStock: this.iboData[0].idCompanyStock,
          lockupDate: formVal.lockupDate,
          lockupStock: formVal.discountList,
          askSize: formVal.ask_size
        }
        data.idIBOSellorder = this.iboData[0].idIBOSellorder;
        this._api.fetchApiData(this._urls.updateIBOUrl, data).subscribe(
          (data: any) => {
            let resSucc = data.data;
            let resErr = data.error;
            this._utils.scrollToY(0, 400, 'easeInOutQuint');
            if (resSucc != '') {
              this.alertStatusMessage = true;
              this.responseMessage = resSucc['Success Description'];
              setTimeout(() => {
                this.router.navigate(['ibo/list']);
              }, 2000);
            }
            if (resErr != '') {
              this.alertStatusMessage = false;
              this.responseMessage = resErr['Error Description'];
            }

          },
          error => {

          },
          () => {
            this.showLoader = false;
          }
        )
      }

    }
  }
  cancelIBOCreate() {
    this.router.navigate(['ibo/list']);
  }

  public targetSymbols(data): void {
    this.targetPair = data.symbol;
  }


  numberValidation(input: FormControl) {
    let val = input.value;
    let regex = /^[0-9]+([,.][0-9]+)?$/g;
    if (!regex.test(val) && val != '') {
      return {
        numberValid: true
      }
    }
    return null;
  }


  addDiscountMultiple(): void {
    let discount = this.createIBOForm.get('discountList') as FormArray;
    discount.push(this.createDiscount());
  }

  deleteDiscountMultiple(i) {
    let discount = this.createIBOForm.get('discountList') as FormArray;
    discount.removeAt(i);
  }

  getMarketList() {
    this._api.fetchApiData(this._urls.marketListUrl, {}, 'get').subscribe(
      (data: any) => {
        let resSucc = data.data;
        if (resSucc != '') {
          this.marketList = (this.actionType == 'add') ? this._utils.filteredObj(resSucc, 'isIBO', false) : resSucc;
        }
      },
      error => {

      },
      () => {

      }
    )
  }

  getIBOData() {
    let data = {
      idCompanyStock: this.iboId
    }
    this.showLoader = true;
    this._api.fetchApiData(this._urls.getIBObyIdUrl, data, 'post').subscribe(
      (data: any) => {
        this.iboData = data.data;
        this.showLoader = false;
        if (this.iboData != '') {
          this.setIBODetails(this.iboData[0]);
        }
      },
      error => {

      },
      () => {

      }
    )
  }

  setIBODetails(data) {
    let discount = data.lockupStock;
    let discFields = <FormArray>this.createIBOForm.get('discountList');
    discFields.removeAt(0);
    let discFieldVal = <FormControl>this.createIBOForm.get('discountList').value;
    let targetSymbol = this._utils.filteredObj(this.targetSymbol, 'symbol', data.pairTarget);
    this.createIBOForm.patchValue({
      'companies_edit': data.companyName,
      'source_symbol_edit': data.pairSource,
      //'target_symbol': data.pairTarget,
      'target_symbol_edit': data.pairTarget,
      'initial_value': data.initialValue,
      // 'ask_price': data.askPrice,
      'ask_size': data.askSize,
      'lockupDate': data.lockupDate,
      'userId': data.idUser
    });

    discount.forEach(ele => {
      discFields.push(this.createDiscount(ele.discount, ele.expiry, ele.idLockupStock))
    });

  }
  getSymbolList() {
    let url: string;
    if (this.isDemo) url = this._urls.listDemoSymbolUrl;
    this._api.fetchApiData(url, {}).subscribe(
      (data: any) => {
        let resSucc = data.data;
        if (resSucc != '') this.symbolList = resSucc;
      },
      error => {

      },
      () => {

      }
    )
  }
  getCompanyList() {
    let url = (this.isDemo) ? this._urls.listDemoCompanyUrl : this._urls.compListUrl;
    this._api.fetchApiData(url, {}).subscribe(
      (data: any) => {
        let resSucc = data.data.companyList;
        if (resSucc != '') this.companyList = resSucc;
      },
      error => {

      },
      () => {

      }
    )
  }
  getPrimarySymbol() {
    let url = (this.isDemo) ? this._urls.primaryDemoSymbolUrl : this._urls.primarySymbolUrl;
    this._api.fetchApiData(url, {}).subscribe(
      (data: any) => {
        let resSucc = data.data;
        let resErr = data.error;
        if (resSucc != '') this.targetSymbol = resSucc;

      },
      error => {

      },
      () => {
        this.showLoader = false;
      }
    )
  }
  changeToCapital() {
    let SourceCaps = this.createIBOForm.controls['source_symbol'].value;
    this.createIBOForm.controls['source_symbol'].setValue(SourceCaps.toUpperCase());
  }
  ngOnInit() {
    this.createIBOFormInit();
    this.getCompanyList();
    // this.getSymbolList();
    this.getPrimarySymbol();
    this._ac.params.subscribe(
      params => {
        this.iboId = params.id;
        this.getIBOData();
      }
    )
  }

  public selectIbin(data): void {
    this.ibinCompany = data.ibin;
    // this.createIBOForm.controls['ibin'].setValue(data.ibin);

  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/ibo/add-ibo/add-ibo.component.ts